export default __webpack_public_path__ + "static/media/arrow_1.b42d1998.svg";